import { useLocation } from 'react-router-dom'

const useQueryPage = (): number => {
  const search = useLocation().search
  const pageFromQuery = new URLSearchParams(search).get('page')
  return pageFromQuery ? Number(pageFromQuery) : 1
}

export default useQueryPage
